export * from "./ProjectMonitoringDetailTemplate";
